/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Typography, Grid } from '@mui/material';
import {
    AlertError,
    CallBox,
    CallButton,
    CallDetails,
    CallHeader,
    CallStateError,
} from './call-styles';
import { Close, ErrorOutline, Phone } from '@mui/icons-material';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import React from 'react';
import { formatUSPhoneNumber } from '../../utils/formatter';
import CallWarningActions from './call-warning-actions';
import { useCallIdentity } from '../../hooks/use-call-identity';


export default function CallErrorPbxNotConfigured() {
    const { phoneNumber, hideWarning } = usePhoneWarnings();
    const { contactNames } = useCallIdentity({ phoneNumber: phoneNumber as string });

    return (
        <CallBox data-testid='call-error-phone-in-use'>
            <CallHeader>
                <Grid container>
                    <Grid item xs={6} zeroMinWidth>
                        <CallStateError>ERROR</CallStateError>
                        <Typography variant='h6' noWrap>
                            {contactNames ? contactNames : ''}
                        </Typography>
                        <Typography variant='body2'>{formatUSPhoneNumber(phoneNumber!)}</Typography>
                        <Typography variant='body2'>--:--</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <CallButton disabled sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}>
                            <Phone />
                        </CallButton>
                        <CallButton onClick={hideWarning}>
                            <Close sx={{ fontSize: 32 }} />
                        </CallButton>
                    </Grid>
                </Grid>
                <AlertError icon={<ErrorOutline style={{ fontSize: 22, color: '#E31B0C' }} />} severity='error'>
                    To use Phone services your user account needs to be configured in your PBX. 
                    To resolve this issue, please reach out to our Support Team at 847-597-1745 
                    extension 1, option 2 or email <a href="mailto:support@revenuewell.com">support@revenuewell.com</a>.
                </AlertError>
            </CallHeader>
            <CallDetails>
                <CallWarningActions phoneNumber={phoneNumber!} />
            </CallDetails>
        </CallBox>
    );
}
